import React from "react";
import { BsCalendarMinusFill } from "react-icons/bs";

export default function SingleAppointment({ date, time, product, clinicanName, bookingId }) {
  return (
    <div className="appointmentContent">
      <div>
        <h4>{date}</h4>
        <p>{time}</p>
      </div>
      <div className="borderContent">
        <p>Product</p>
        <h6>{product}</h6>
      </div>
      <div>
        <p>clinician</p>
        <h5>{clinicanName}</h5>
      </div>

      <button
        className="viewDetailsBtn"
        onClick={() => {
          // window.location.href = `/BookingDetails?${bookingId}`;
          window.open(`/BookingDetails?bookingId=${bookingId}`, "_blank");
        }}
      >
        <BsCalendarMinusFill />
        <span>View Details</span>
      </button>
    </div>
  );
}
